import { Link as RouterLink, Outlet } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
// components
import Logo from '../components/Logo';
import LanguagePopover from './dashboard/LanguagePopover';
import { Box, AppBar, Toolbar, Stack } from '@mui/material';
// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  // boxShadow: 'none',
  // backdropFilter: 'blur(6px)',
  // WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile

  [theme.breakpoints.up('lg')]: {
    width: `100%`
  }
}));
const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <RootStyle className="topBar"> 
        <ToolbarStyle >

          <Box sx={{ flexGrow: 1, height: "100%" }}  >
            <Logo />
          </Box>
          
          <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
            <LanguagePopover />
            {/* <NotificationsPopover /> */}
        
          </Stack>

        </ToolbarStyle>
      </RootStyle>
      <Outlet />
    </>
  );
}
